import { Box, Flex, Text, Button, Stack } from '@chakra-ui/react';
import { usePengetahuanDetailContext } from '../../controller/pengetahuan/detail';
import { usePengetahuanAssesmentContext } from '../../controller/pengetahuan/assesment';
import ModalUploadAssesment from '../Admin/ModalPengetahuan/ModalUploadAssesment';
import { FaFileDownload } from 'react-icons/fa';
import { parseISO, differenceInHours } from 'date-fns';
import { MdUpload } from 'react-icons/md';

/**
 * Renders the AssesmentPengetahuan component.
 *
 * @return {JSX.Element} The rendered component.
 * @author Bagas Prasetyadi
 */
const AssesmentPengetahuan = () => {
  const { pengetahuanItem } = usePengetahuanDetailContext().state;
  const { isLoadingDownload } = usePengetahuanAssesmentContext().state;
  const { downloadAssesment } = usePengetahuanAssesmentContext().dispatch;

  const pengetahuanId = window.location.pathname.split('/', 4)[3];

  if (!pengetahuanItem?.pengetahuan_materi_saya?.has_assessment) {
    return (
      <Box    w="full"
        bg="gray.50"
        rounded="lg"
        p={4}
        border="1px"
        borderColor="gray.400"
      >
        <Text fontSize="md" fontWeight="semibold" textAlign="center" w="full">
          Tidak ada tugas mandiri pada pengetahuan ini
        </Text>
      </Box>
    );
  }

  const startAssesmentSync =
    pengetahuanItem && parseISO(pengetahuanItem?.jadwal_selesai);
  const startAssesmentASync =
    pengetahuanItem &&
    (parseISO(pengetahuanItem?.tanggal_download_asesmen) as Date);
  const currentDate = new Date();

  const startAssesment =
    pengetahuanItem?.jenis_pengetahuan === 'synchronized'
      ? startAssesmentSync
      : startAssesmentASync;

  let diffHours = 0;

  if (startAssesment instanceof Date) {
    diffHours = differenceInHours(currentDate, startAssesment);
  }

  //  hide upload file access after 5 days
  const hoursInFiveDays = 5 * 24;

  const shouldHideUploadFile =
    diffHours >= hoursInFiveDays ||
    pengetahuanItem?.status_pengetahuan === 'selesai';

  const linkDriveAssesment =
    pengetahuanItem?.pengetahuan_materi_saya?.t_pengetahuan_asesmen?.assessment_files.find(
      (file) => file.link_drive !== null
    );

  const isVideoLocked =
    !pengetahuanItem?.has_completed_video &&
    pengetahuanItem?.pengetahuan_materi_saya?.category === 'video';

  const renderAction = () => {
    return (
      <Stack direction="column" spacing={2}>
        <Button
          size="sm"
          colorScheme="orange"
          isLoading={isLoadingDownload}
          rightIcon={<FaFileDownload />}
          disabled={isVideoLocked}
          onClick={() =>
            downloadAssesment(
              pengetahuanId,
              pengetahuanItem?.pengetahuan_materi_saya?.t_pengetahuan_asesmen
                ?.judul,
              pengetahuanItem?.tanggal_download_asesmen,
              pengetahuanItem?.jenis_pengetahuan
            )
          }
        >
          Download
        </Button>

        {linkDriveAssesment && !shouldHideUploadFile && (
          <Button
            size="sm"
            colorScheme="blue"
            rightIcon={<MdUpload />}
            disabled={isVideoLocked}
            onClick={() =>
              window.open(linkDriveAssesment.link_drive ?? '#', '_blank')
            }
          >
            Upload
          </Button>
        )}
      </Stack>
    );
  };

  return (
    <>
      <Box
        w="full"
        bg="gray.50"
        rounded="lg"
        p={4}
        border="1px"
        borderColor="gray.400"
      >
        <Flex justify="space-between" align="center">
          <Box>
            <Text fontSize="md" fontWeight="semibold" color="gray.800">
              Tugas Mandiri
              </Text>
            <Text fontSize="sm" color="gray.600">
              Download tugas dan upload file tugas yang sudah dikerjakan.
            </Text>
          </Box>
          {renderAction()}
        </Flex>
      </Box>

      <ModalUploadAssesment />
    </>
  );
};

export default AssesmentPengetahuan;
